import {
  makeObservable, observable, flow, action, computed,
} from 'mobx';
import { toast } from 'sonner';

import { api } from '@/lib/services';
import { ApiRoutes } from '@/lib/routes';

import CreateSegmentSchema from '@/areas/inventory/schemas/CreateSegmentSchema';

export default class CreateSegmentStore {
  visible = false;

  processing = false;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      processing: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
      canCreate: computed,
    });

    this.parentStore = parentStore;
  }

  get canCreate() {
    return this.parentStore.parentStore.authenticationStore.isAdmin;
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  toggle(visible) {
    if (visible === true || visible === false) {
      this.visible = visible;
    } else {
      this.visible = !this.visible;
    }
  }

  * save(data) {
    const parseResult = CreateSegmentSchema.safeParse(data);
    if (!parseResult.success) {
      return parseResult;
    }

    try {
      this.processing = true;
      const response = yield api.post(ApiRoutes.forSegments(), parseResult.data);
      this.visible = false;
      toast.success('Segment created', {
        description: response.data?.softCapWarning
          ? 'Heads up: tenant is approaching the soft cap of 20 active segments.'
          : undefined,
      });
      return { success: true, data: response.data };
    } catch (e) {
      toast.error('Error creating segment', {
        description: e?.response?.data?.message || e?.response?.data || 'Unexpected error, please try again later.',
      });
      return { success: false, error: e };
    } finally {
      this.processing = false;
    }
  }
}
